import React from 'react';

import { useTranslation } from 'react-i18next';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import CommunitiesList from '../../../components/reusable/communities-list/CommunitiesList';
import { useGetUserCommunities } from '../../../services/redux/api/usersApi';
import withRouter from '../../../hooks/with-router';
import { useNotFound } from '../../../hooks/useNotFound';
import { useStyles } from './UserCommunites.styles';
import theme from '../../../styles/theme';

function UserCommunities(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const { data: communities, isFetching } = useGetUserCommunities(
    params.userId,
  );
  useNotFound(!isFetching && !communities);
  const { classes } = useStyles(theme);

  return (
    <PageContainer title={t('user.communities')} backButton>
      <div className={classes.communitiesWrapper}>
        <CommunitiesList communities={communities} />
      </div>
    </PageContainer>
  );
}

export default withRouter(UserCommunities);
